export function QCheckPoint() {
  this.fDBJournal = null;
  this.fSCMJournal = null;
  this.fPMJournal = null;
  this.fBGJournal = null;
  this.fDBOverrideJournal = null;
}
